import { cx } from "cva";

import { OpenInNewIcon } from "../Icon";
import { SubtleButtonExternalLinkProps, variants } from ".";

export const SubtleButtonExternalLink = ({
  className,
  children,
  align,
  radius,
  width,
  title,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  disabled,
  onClick,
  ...props
}: Readonly<SubtleButtonExternalLinkProps>) => (
  <a
    href={href}
    title={title}
    aria-disabled={disabled}
    target={target}
    rel={rel}
    className={cx(variants({ align, radius, width }), className)}
    tabIndex={disabled ? -1 : undefined}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    <span>
      {children}
      <span className="sr-only">(別ウィンドウで開きます)</span>
      <OpenInNewIcon size="s" className="mb-1 ml-1 inline" />
    </span>
  </a>
);
